/* eslint-disable */

import { createApp } from 'vue'
/* import { createStore } from 'vuex' */
import App from './App.vue'

import mitt from 'mitt';
const emitter = mitt();

import { BackgroundMode } from '@ionic-native/background-mode';
import { Insomnia } from '@ionic-native/insomnia';

import { KeepAwake } from '@capacitor-community/keep-awake';

import { Capacitor } from '@capacitor/core';

import { isAuthenticated } from './router';

declare global {
  interface Window {
    __vybrooDeferredInstallPrompt?: any;
    __VUE_OPTIONS_API__?: boolean;
    __VUE_PROD_DEVTOOLS__?: boolean;
    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__?: boolean;
    __emitter?: any;
  }
}

// Fallback runtime flags para evitar warning si el bundler no aplico DefinePlugin aun.
window.__VUE_OPTIONS_API__ = true;
window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

const keepAwake = async () => {
  if (Capacitor.getPlatform() != 'web') {
    await KeepAwake.keepAwake();
  }
};

const allowSleep = async () => {
  await KeepAwake.allowSleep();
};

import router from './router';
import {
  IonicVue,
  IonIcon,
  IonText,
  IonImg,
  IonButton,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonGrid,
  IonRow,
  IonCol,
  IonLabel,
  IonItem,
  IonList,
  IonListHeader,
  IonCheckbox,
  IonAvatar,
  IonThumbnail,
  IonInput,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonCardContent,
} from '@ionic/vue';
/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/admin_variables.css';


// const store = createStore(storeData);

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  // .use(VueAxios)

app.component('IonIcon', IonIcon);
app.component('IonText', IonText);
app.component('IonImg', IonImg);
app.component('IonButton', IonButton);
app.component('IonToolbar', IonToolbar);
app.component('IonButtons', IonButtons);
app.component('IonMenuButton', IonMenuButton);
app.component('IonTitle', IonTitle);
app.component('IonGrid', IonGrid);
app.component('IonRow', IonRow);
app.component('IonCol', IonCol);
app.component('IonLabel', IonLabel);
app.component('IonItem', IonItem);
app.component('IonList', IonList);
app.component('IonListHeader', IonListHeader);
app.component('IonCheckbox', IonCheckbox);
app.component('IonAvatar', IonAvatar);
app.component('IonThumbnail', IonThumbnail);
app.component('IonInput', IonInput);
app.component('IonInfiniteScroll', IonInfiniteScroll);
app.component('IonInfiniteScrollContent', IonInfiniteScrollContent);
app.component('IonCard', IonCard);
app.component('IonCardHeader', IonCardHeader);
app.component('IonCardTitle', IonCardTitle);
app.component('IonCardSubtitle', IonCardSubtitle);
app.component('IonCardContent', IonCardContent);

// BackgroundMode.enable();

router.isReady().then(() => {
  app.config.globalProperties.emitter = emitter;
  window.__emitter = emitter;
  app.mount('#app');

  if (Capacitor.getPlatform() == 'web' && 'serviceWorker' in navigator) {
    if (process.env.NODE_ENV === 'production') {
      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        window.__vybrooDeferredInstallPrompt = event;
        window.dispatchEvent(new CustomEvent('vybroo-beforeinstallprompt-ready'));
      });

      navigator.serviceWorker.register('/service-worker.js')
        .then(() => {
          console.log('Service worker PWA registrado');
        })
        .catch((error) => {
          console.warn('No se pudo registrar el service worker PWA:', error);
        });
    } else {
      navigator.serviceWorker.getRegistrations()
        .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
        .then(() => {
          console.log('Service workers desregistrados en entorno de desarrollo');
        })
        .catch((error) => {
          console.warn('No se pudieron desregistrar service workers en desarrollo:', error);
        });
    }
  }

  if (Capacitor.getPlatform() != 'ios'){
    BackgroundMode.enable();
  }
  keepAwake();
});

// declare global {
//   interface Window { 
//     hub: any; 
//     xhr: any; 
//     timeouts: any;
//     audio: any;
//     video: any;
//     vm: any;
//     cleanHash: any;
//     oaudio: any; }
// }


// // The global object for comunications between components
// window.hub = createApp(App);

// // XHR Library for AJAX
// window.xhr = axios;

// // Timeouts object
// window.timeouts = {};

// // Core setup steps
// // Setting the hash in case it's blank
// if(window.location.hash == '' && localStorage.lastlink) {
//   window.location.hash = localStorage.lastlink;
// }

// // Global helpers
// window.cleanHash = () => {
//   const rawHash = window.location.hash.match(/[a-z0-9]/gi);
//   if (!rawHash) return "";
//   return rawHash.join('');
// };

// // Global objects that require no reactivity
// window.audio = new Audio();
// window.video = document.getElementById('video');
// window.oaudio = new Audio();
// window.timeouts = {};

// // The main instance that launches the app
// window.vm = createApp(App);